import { type BreakpointsProps } from '@/types';
import { HTMLAttributes, ReactNode } from 'react';
import {
  StyledBody,
  StyledCard,
  StyledCardInner,
  StyledDecoratorImg,
  StyledHeader,
  StyledInactive,
} from './Card.styles';

export interface CardProps
  extends HTMLAttributes<HTMLDivElement>,
    BreakpointsProps<Pick<CardProps, 'width' | 'height'>> {
  body?: ReactNode;
  header?: ReactNode;
  height?: string;
  width?: string;
  decoratorImg?: ReactNode;
  footer?: ReactNode;
  inactive?: boolean;
}

const Card = ({
  decoratorImg,
  footer,
  body,
  header,
  inactive,
  ...restProps
}: CardProps) => {

  return (
    <StyledCard data-testid="card" hasMask={!!decoratorImg} {...restProps}>
      <StyledCardInner>
        {decoratorImg && (
          <StyledDecoratorImg>{decoratorImg}</StyledDecoratorImg>
        )}
        {header && <StyledHeader>{header}</StyledHeader>}
        {body && <StyledBody>{body}</StyledBody>}
        {footer}
        {inactive && <StyledInactive hasDecoratorImg={!!decoratorImg} />}
      </StyledCardInner>
    </StyledCard>
  );
};

export default Card;
